export function scrollToElementWithOffset(element: Element, offset: number): void {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.pageYOffset + offset,
    behavior: 'smooth',
  });
}
